<template>
  <div
    class="space-create-form"
  >
    <scroll-container
      no-padding-bottom
      class="_content"
    >
      <m-content
        :padding-x="11"
      >
        <space-general-form
          v-model:space="space"
        />
        <space-permissions
          v-model:space="space"
          is-create
          @update:permissions="updatePermissions"
        />
      </m-content>
    </scroll-container>
    <m-content
      :padding-x="11"
      :padding-y="8"
      class="_actions"
    >
      <m-btn
        small
        super-light
        :href="$t('spaceList.helpCenterLink')"
        hide-border
        icon="question-circle"
        target="_blank"
      >
        {{ $t('spaceList.learnMore') }}
      </m-btn>
      <m-tooltip
        :disabled="formIsValid"
      >
        <m-btn
          color="primary"
          :loading="loading"
          :disabled="!formIsValid"
          @click="create"
        >
          {{ $t('general.create') }}
        </m-btn>
        <template #title>
          {{ formValidationHint }}
        </template>
      </m-tooltip>
    </m-content>
  </div>
</template>

<script setup>
import ScrollContainer from '@/components/page/ScrollContainer.vue';
import SpaceGeneralForm from '@/components/spaces/SpaceGeneralForm.vue';
import SpacePermissions from '@/components/spaces/SpacePermissions.vue';
import useGoalSettings from '@/composables/logged-in-user-account/goal-settings';
import useSnackBar from '@/composables/snackbar';
import useSpaceFormValidator from '@/composables/space/form-validator';
import useSpaces from '@/composables/space/spaces';
import { accessPolicyType, optionColor } from 'shared/constants.json';
import { copyAccessPolicy } from '@/lib/access-policy';
import { logCatch } from '@/lib/logger/logger';
import { ref } from 'vue';

const spacesSvc = useSpaces();
const { createSpaceLoading: loading } = spacesSvc;
const snackbar = useSnackBar();
const { goalSettings } = useGoalSettings();

const props = defineProps({
  space: {
    type: Object,
    default: () => {},
  },
});

const emptySpace = {
  title: '',
  color: optionColor.default,
  parents: [],
  description: null,
  properties: [],
  accessRight: accessPolicyType.full,
  permissions: {
    ...copyAccessPolicy(goalSettings.value.defaultAccessPolicy),
    spaceOwnerAccess: accessPolicyType.full,
    spaceMemberAccess: [accessPolicyType.full].includes(goalSettings.value.defaultAccessPolicy.accountAccess) ? goalSettings.value.defaultAccessPolicy.accountAccess : accessPolicyType.write,
  },
};
const space = ref({ ...emptySpace, ...props.space });

const updatePermissions = (permissions) => {
  space.value.permissions = { ...space.value.permissions, ...permissions };
};

const { formIsValid, formValidationHint } = useSpaceFormValidator(space);

const emit = defineEmits(['created']);
const create = () => {
  spacesSvc.createSpace(space.value).then((data) => {
    emit('created', data);
  }).catch(logCatch(() => {
    snackbar.error();
  }));
};
</script>

<style scoped lang="scss">
.space-create-form {
    ._content {
        max-height: 65vh;
    }

    ._actions {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid $input-border-color;
    }
}
</style>
